<template>
  <div id="home-page">
    <div class="app-head">
      <div class="head-graphics">
        <img v-parallax="0.4" v-parallax.absY="0.2" v-parallax.scale="0.6" class="blur-1" src="../assets/blur-1.png" alt="">
        <img v-parallax="0.4" v-parallax.absY="0.2" v-parallax.scale="0.6" class="blur-2" src="../assets/blur-2.png" alt="">
      </div>
      <div class="head-content">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-md-10 text-center">
              <h1 class="mb-4 fw-800" v-html="$t('appHead.mainTitle')"></h1>
            </div>
          </div>
          <div class="row justify-content-center mb-5">
            <div class="col-md-9 text-center">
              <h2 class="thin mb-5" v-html="$t('appHead.subTitle')"></h2>
              <a href="https://www.wirecard.com/contact/sales" class="btn btn-red btn-arrow"><span>{{ $t('footer.aboutButton') }}</span></a>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-md-10">
              <div class="available-options d-block d-lg-flex align-items-center justify-content-between">
                <div class="av-methods d-block d-md-flex align-items-center text-center text-md-left mb-5 mb-lg-0">
                  <p class="mb-0 text-center text-md-left mb-3 mb-md-0">{{ $t('paymentMethods') }}</p>
                  <div class="av-logo d-inline-block d-md-block"><img src="../assets/mastercard.png" alt=""></div>
                  <div class="av-logo d-inline-block d-md-block"><img src="../assets/visa.png" alt=""></div>
                </div>
                <div class="av-systems d-block d-md-flex align-items-center text-center text-md-left">
                  <p class="mb-0 text-center text-md-left mb-3 mb-md-0">{{ $t('ecommerceSystems') }}</p>
                  <div class="av-logo d-inline-block d-md-block"><img src="../assets/magento-type-filled.png" alt=""></div>
                  <div class="av-logo d-inline-block d-md-block"><img src="../assets/presta.png" alt=""></div>
                  <div class="av-logo d-inline-block d-md-block"><img src="../assets/woo.png" alt=""></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="head-angles blue">
        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="100%" height="160" viewBox="0 0 100 100" preserveAspectRatio="none">
          <defs>
            <linearGradient class="svg-fill-14" id="blueGradientHead" x1="50%" x2="100%">
              <stop offset="0%"></stop>
              <stop offset="100%"></stop>
            </linearGradient>
          </defs>
          <g>
            <path d="M6 100 L100 100 L100 0 Z" fill="url(#blueGradientHead)"></path>
            <path class="pale-blue-bg" d="M0 100 L100 100 L100 25 Z" fill="#fff"></path>
          </g>
        </svg>
      </div>
    </div>

    <div id="features" class="container">
      <div class="row justify-content-center">
        <div class="col-lg-8">
          <div class="wc-card animated from-small-bottom" v-is-in-view="{showIfPartial: true}">
            <img src="../assets/card-refresh.svg" alt="" class="mb-2 ">
            <div class="row mb-2">
              <div class="col-lg-8">
                <h4>{{ $t('features.title') }}</h4>
              </div>
            </div>
            <p class="mb-0">{{ $t('features.description.p1') }}</p>
            <p class="mb-0">{{ $t('features.description.p2') }}</p>
            <p class="mb-0">{{ $t('features.description.p3') }}</p>
            <ul class="home-features mb-5">
              <li>{{ $t('features.feat1') }}</li>
              <li>{{ $t('features.feat2') }}</li>
              <li>{{ $t('features.feat3') }}</li>
              <li>{{ $t('features.feat4') }}</li>
              <li>{{ $t('features.feat5') }}</li>
            </ul>

            <div class="d-flex justify-content-center"><a href="https://www.wirecard.com/contact/sales" class="btn btn-red btn-arrow"><span>{{ $t('footer.aboutButton') }}</span></a></div>

          </div>
        </div>
      </div>
    </div>

    <div id="video-section" class="container-fluid pr-0 ovx-h">
      <div class="row">
        <div id="video-col" class="col-lg-5 animated from-small-left" v-is-in-view="{showIfPartial: true}">
          <div class="row justify-content-end">
            <div class="col-lg-8">
              <div class="video-box perspective">
                <div class="play-btn" v-on:click="this.onShowMarketingModal"></div>
                <vue-plyr :options="playerOptions" ref="marketingPlayer">
                  <div data-plyr-provider="vimeo" data-plyr-embed-id="303034859"></div>
                  <!-- <div class="plyr__video-embed">
                    <iframe
                    src="https://player.vimeo.com/video/303034859?loop=true&amp;byline=false&amp;portrait=false&amp;title=false&amp;speed=true&amp;transparent=0&amp;gesture=media&amp;background=1"
                    allowfullscreen allowtransparency allow="autoplay">
                    </iframe>
                  </div> -->
                </vue-plyr>
              </div>
              <h3>{{ $t('video.title') }}</h3>
              <p>{{ $t('video.description') }}</p>
              <a href="#" class="btn btn-blue btn-arrow" @click="this.onShowTutorialModal"><span>{{ $t('video.button') }}</span></a>
            </div>
          </div>
        </div>
        <div class="col-lg-7 d-none d-lg-flex animated from-small-right dl-300" v-is-in-view="{showIfPartial: true}">
          <div class="notebook-graphics w-100 h-100">
            <img src="../assets/notebook-graphics-gray.png" alt="">
          </div>
        </div>
      </div>
    </div>

    <div id="references">
      <div class="container">
        <h3 class="text-center mb-5">{{ $t('references.title') }}</h3>
        <div class="row">
          <div class="col-lg-4 mb-3 mb-lg-0">
            <div class="ref-card animated from-small-bottom dl-0" v-is-in-view="{showIfPartial: true}">
              <figure><img src="../assets/ref1.jpg" alt=""></figure>
              <div class="ref-content">
                <p>{{ $t('references.ref1.content') }}</p>
                <p class="ref-author">
                  <strong>Alexander Brandenstein</strong>
                  <span>{{ $t('references.ref1.role') }}</span>
                </p>
                <a href="#" class="ref-logo"><img src="../assets/ref-logo-1.png" alt=""></a>
              </div>
            </div>
          </div>
          <div class="col-lg-4 mb-3 mb-lg-0">
            <div class="ref-card animated from-small-bottom dl-300" v-is-in-view="{showIfPartial: true}">
              <figure><img src="../assets/ref2.jpg" alt=""></figure>
              <div class="ref-content">
                <p>{{ $t('references.ref2.content') }}</p>
                <p class="ref-author">
                  <strong>Daniel Straub</strong>
                  <span>{{ $t('references.ref2.role') }}</span>
                </p>
                <a href="#" class="ref-logo"><img src="../assets/ref-logo-2.png" alt=""></a>
              </div>
            </div>
          </div>
          <div class="col-lg-4 mb-3 mb-lg-0">
            <div class="ref-card animated from-small-bottom dl-600" v-is-in-view="{showIfPartial: true}">
              <figure><img src="../assets/ref3.jpg" alt=""></figure>
              <div class="ref-content">
                <p>{{ $t('references.ref3.content') }}</p>
                <p class="ref-author">
                  <strong>Jabarjit Singh</strong>
                  <span>{{ $t('references.ref3.role') }}</span>
                </p>
                <a href="#" class="ref-logo"><img src="../assets/ref-logo-3.png" alt=""></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="bottom-form" class="container ">
      <div class="d-flex justify-content-center"><a href="https://www.wirecard.com/contact/sales" class="btn btn-red btn-arrow"><span>{{ $t('footer.aboutButton') }}</span></a></div>
    </div>

    <Modal v-show="this.showMarketingModal" :show="this.showMarketingModal" @close-modal="onCloseMarketingModal" size="modal-lg" class="no-padding">
      <vue-plyr :options="marketingPlayerModalOptions" ref="marketingPlayerModal">
        <div class="plyr__video-embed">
          <iframe
          src="https://player.vimeo.com/video/303034859?loop=false&amp;byline=false&amp;portrait=false&amp;title=false&amp;speed=true&amp;transparent=0&amp;gesture=media&amp;background=1"
          allowfullscreen allowtransparency allow="autoplay">
          </iframe>
        </div>
      </vue-plyr>
    </Modal>

    <Modal v-show="this.showTutorialModal" :show="this.showTutorialModal" @close-modal="onCloseTutorialModal" size="modal-lg" class="no-padding">
      <vue-plyr :options="tutorialPlayerOptions" ref="tutorialPlayer">
        <div class="plyr__video-embed">
          <iframe
          src="https://player.vimeo.com/video/304336146?loop=false&amp;byline=false&amp;portrait=false&amp;title=false&amp;speed=true&amp;transparent=0&amp;gesture=media&amp;background=1"
          allowfullscreen allowtransparency allow="autoplay">
          </iframe>
        </div>
      </vue-plyr>
    </Modal>
  </div>
</template>

<script>
import 'custom-event-polyfill';
import 'url-polyfill';
import { mapState } from 'vuex'
import { VuePlyr } from 'vue-plyr'
import Modal from '@/components/Modal.vue'
import AliasForm from '@/components/AliasForm.vue'

export default {
  name: 'home',
  components: {
    VuePlyr,
    Modal,
    'alias-form': AliasForm
  },
  data() {
    return {
      playerOptions: {
        controls: () => { },
        autoplay: true,
        volume: 0
      },
      marketingPlayerModalOptions: {
        volume: 1
      },
      tutorialPlayerOptions: {
        volume: 1
      },
      showMarketingModal: false,
      showTutorialModal: false
    }
  },
  computed: {
    ...mapState({
      firstName: state => state.user.firstName
    })
  },
  methods: {
    updateFirstName(e) {
      this.$store.commit('updateFirstName', e.target.value)
    },
    nextPage(payload) {
      this.$router.push(payload.url)
    },
    onShowMarketingModal(e) {
      e.preventDefault()
      this.showMarketingModal = true
      this.$refs.marketingPlayer.player.pause()
      this.$refs.marketingPlayerModal.player.play()
    },
    onCloseMarketingModal() {
      this.showMarketingModal = false
      this.$refs.marketingPlayer.player.play()
      this.$refs.marketingPlayerModal.player.stop()
    },
    onShowTutorialModal(e) {
      e.preventDefault()
      this.showTutorialModal = true
      this.$refs.tutorialPlayer.player.play()
    },
    onCloseTutorialModal() {
      this.showTutorialModal = false
      this.$refs.tutorialPlayer.player.stop()
    }
  },
  mounted() {
    // mute the player
    if (this.$refs.marketingPlayer.player) {
      this.$refs.marketingPlayer.player.on('ready', (event) => {
        const instance = event.detail.plyr
        instance.muted = true
      })
    }
  }
};
</script>

<style lang="scss" scoped>
  .embed-container { position: relative; padding-bottom: 56.25%; height: 0; overflow: hidden; max-width: 100%; height: auto; }
  .embed-container iframe, .embed-container object, .embed-container embed { position: absolute; top: 0; left: 0; width: 100%; height: 100%; }
</style>
